import { makeEroadStyles } from "../../../styles";

const useStyles = makeEroadStyles(
  (theme) => ({
    children: {
      ...theme.typography.sizes.lg,
      color: theme.colors.onsurfaceFont,
      fontWeight: 500,
      marginTop: theme.spacing(6),
    },
  }),
  { name: "PageSubtitle" }
);

export { useStyles };
